module.exports = __webpack_public_path__ + "static/hcm-slider3-c272f39038fef908956ab3359d4ebddc.jpeg";